import TimeManagementScreen from '../../components/time-management/index.jsx'

export default function TimeManagementPage() {
	return (
		<div>
			<TimeManagementScreen />
		</div>
	)
}
